<div class="us-right-row">
    <div class="flex-fill">{{CHECKSHEETSETTINGDIALOG.SORT_ORDER}}</div>
    <div class="us-right-item">
        <div class="d-flex" (click)="onNyuShoRadioClick('sortRoom')">
            <caremoni-radio-button [isChecked]="isSortByRoom" [disabled]="false"
                [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="0">
            </caremoni-radio-button>
            <label for="rdSortRoom" [ngClass]="{'disabled': false}" class="us-right-item-lable">{{CHECKSHEETSETTINGDIALOG.SORT_ROOM_NYUSHO}}</label>
        </div>
        <div class="d-flex" 
            (click)="onNyuShoRadioClick('sortName')">
            <caremoni-radio-button [isChecked]="isSortByName"[disabled]="false"
                [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="1" [ydpad]="0">
            </caremoni-radio-button>
            <label for="rdSortName" [ngClass]="{'disabled': false}" class="us-right-item-lable">{{CHECKSHEETSETTINGDIALOG.SORT_NAME_NYUSHO}}</label>
        </div>
    </div>
</div>
<div class="us-right-row">
    <div class="flex-fill">{{CHECKSHEETSETTINGDIALOG.TIME_RANGE_NYUSHO}}</div>
    <div class="d-flex">
        <caremoni-tv-select [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="1"
            [id]="'time-range-select'"
            [options]="timeRanges" [selectedValue]="timeRangeSelected" 
            (valueChange)="onChangeTimeRange($event)"
        >
        </caremoni-tv-select>
        <label [ngClass]="{'disabled': false}" class="pl-2">時間</label>
    </div>
</div>
<!-- <div class="us-right-row">
    <div class="flex-fill">{{CHECKSHEETSETTINGDIALOG.MARGIN_TO_TIME_NYUSHO}}</div>
    <div class="d-flex">
        <caremoni-select-box [options]="marginToTimes" [selectedValue]="marginToTimeSelected"
            (valueChange)="onChangeMarginToTimes($event)"
            [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="2">
        </caremoni-select-box>
        <label for="rdSortRoom" [ngClass]="{'disabled': false}" class="pl-2">分&nbsp;&nbsp;&nbsp;&nbsp;</label>
    </div>
</div> -->
<div class="us-right-row">
    <div class="flex-fill">{{CHECKSHEETSETTINGDIALOG.DISPLAY_UNIT_NYUSHO}}</div>
    <div class="d-flex">
        <caremoni-tv-multiselect [id]="'unit-multi-select'" [options]="displayUnits" [selectedValues]="unitSelected"
            (valueChange)="onChangeUnit($event)"
            [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="2">
        </caremoni-tv-multiselect>
    </div>
</div>
<div class="us-right-row">
    <div class="flex-fill">{{CHECKSHEETSETTINGDIALOG.DISPLAY_GROUP_NYUSHO}}</div>
    <div class="d-flex">
        <caremoni-tv-multiselect [id]="'group-multi-select'" [options]="displayGroups" [selectedValues]="groupSelected"
            (valueChange)="onChangeGroup($event)"
            [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="3">
        </caremoni-tv-multiselect>
    </div>
</div>